export default [
  {
    path: '/mail/accounts',
    name: 'mail-hub-accounts',
    component: () => import(/* webpackChunkName: "MailHubAccountsList" */ '@/views/mail-hub/accounts/list.vue'),
    meta: {
      layout: 'content',
      module: 'MGN,mail-hub',
    },
  },
  {
    path: '/mail/accounts/create',
    name: 'mail-hub-account-create',
    component: () => import(/* webpackChunkName: "MailHubAccountForm" */ '@/views/mail-hub/accounts/form.vue'),
    meta: {
      layout: 'content',
      module: 'MGN,mail-hub',
    },
  },
  {
    path: '/mail/accounts/:id/edit',
    name: 'mail-hub-account-edit',
    component: () => import(/* webpackChunkName: "MailHubAccountForm" */ '@/views/mail-hub/accounts/form.vue'),
    meta: {
      layout: 'content',
      module: 'MGN,mail-hub',
    },
  },
  {
    path: '/mail/inbox',
    name: 'mail-hub-inbox',
    component: () => import(/* webpackChunkName: "MailHubInbox" */ '@/views/mail-hub/inbox/list.vue'),
    meta: {
      layout: 'content',
      module: 'MGN,mail-hub',
    },
  },
  {
    path: '/mail/thread/:id',
    name: 'mail-hub-thread',
    component: () => import(/* webpackChunkName: "MailHubThread" */ '@/views/mail-hub/thread/detail.vue'),
    meta: {
      layout: 'content',
      module: 'MGN,mail-hub',
    },
  },
  {
    path: '/mail/suggestions',
    name: 'mail-hub-suggestions',
    component: () => import(/* webpackChunkName: "MailHubSuggestions" */ '@/views/mail-hub/suggestions/list.vue'),
    meta: {
      layout: 'content',
      module: 'MGN,mail-hub',
    },
  },
  {
    path: '/mail/leads',
    name: 'mail-hub-leads',
    component: () => import(/* webpackChunkName: "MailHubLeads" */ '@/views/mail-hub/leads/list.vue'),
    meta: {
      layout: 'content',
      module: 'MGN,mail-hub',
    },
  },
  {
    path: '/mail/leads/:id',
    name: 'mail-hub-lead',
    component: () => import(/* webpackChunkName: "MailHubLeadDetail" */ '@/views/mail-hub/leads/detail.vue'),
    meta: {
      layout: 'content',
      module: 'MGN,mail-hub',
    },
  },
  {
    path: '/mail/sent',
    name: 'mail-hub-sent',
    component: () => import(/* webpackChunkName: "MailHubSent" */ '@/views/mail-hub/sent/list.vue'),
    meta: {
      layout: 'content',
      module: 'MGN,mail-hub',
    },
  },
  {
    path: '/mail/channels',
    name: 'mail-hub-channels',
    component: () => import(/* webpackChunkName: "MailHubChannels" */ '@/views/mail-hub/channels/list.vue'),
    meta: {
      layout: 'content',
      module: 'MGN,mail-hub',
    },
  },
  {
    path: '/mail/response-templates',
    name: 'mail-hub-response-templates',
    component: () => import(/* webpackChunkName: "MailHubResponseTemplates" */ '@/views/mail-hub/response-templates/list.vue'),
    meta: {
      layout: 'content',
      module: 'MGN,mail-hub',
    },
  },
  {
    path: '/mail/system-emails',
    name: 'mail-hub-system-emails',
    component: () => import(/* webpackChunkName: "MailHubSystemEmailsPicker" */ '@/views/MGPlatforms.vue'),
    props: true,
    meta: {
      layout: 'content',
      module: 'MGN,mail-hub',
    },
  },
  {
    path: '/mail/system-emails/:context',
    name: 'mundo-gamer-system-emails',
    component: () => import(/* webpackChunkName: "MailHubSystemEmails" */ '@/views/mail-hub/system-emails/list.vue'),
    meta: {
      layout: 'content',
      module: 'MGN,mail-hub',
    },
  },
  {
    path: '/mail/nurture-sequences',
    name: 'mail-hub-nurture-sequences',
    component: () => import(/* webpackChunkName: "NurtureSequencesList" */ '@/views/mail-hub/nurture-sequences/list.vue'),
    meta: {
      layout: 'content',
      module: 'MGN,mail-hub',
    },
  },
  {
    path: '/mail/nurture-sequences/:id/enrollments',
    name: 'mail-hub-nurture-enrollments',
    component: () => import(/* webpackChunkName: "NurtureEnrollmentsList" */ '@/views/mail-hub/nurture-sequences/enrollments.vue'),
    meta: {
      layout: 'content',
      module: 'MGN,mail-hub',
    },
  },
  {
    path: '/mail/settings',
    name: 'mail-hub-settings',
    component: () => import(/* webpackChunkName: "MailHubSettings" */ '@/views/mail-hub/settings/index.vue'),
    meta: {
      layout: 'content',
      module: 'MGN,mail-hub',
    },
  },
  {
    path: '/mail/suppression',
    name: 'mail-hub-suppression',
    component: () => import(/* webpackChunkName: "MailHubSuppression" */ '@/views/mail-hub/suppression/list.vue'),
    meta: {
      layout: 'content',
      module: 'MGN,mail-hub',
    },
  },
]
